// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__cJb+4","Left":"Footer_Left__qXhiD","Right":"Footer_Right__n1D2J"};